import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { AngularSvgIconModule } from 'angular-svg-icon';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MatCheckboxModule,
  MatDialogModule,
  MatFormFieldModule, MatIconModule, MatIconRegistry,
  MatInputModule,
  MatSelectModule,
  MatSidenavModule, MatSliderModule, MatSlideToggleModule, MatSortHeader, MatTableModule,
  MatProgressSpinnerModule,
  MatTabsModule,
  MatAccordion, MatExpansionModule, MatMenuModule, MatChipsModule, MatAutocompleteModule, MatRadioButton, MatRadioModule, MatTooltipModule,
} from '@angular/material';


import { ProfileAvatarComponent } from './components/profile-avatar/profile-avatar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FormFieldComponent } from './components/form-field/form-field.component';
import { SelectComponent } from './components/select/select.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HeaderComponent } from './components/header/header.component';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AlertComponent } from './components/alert/alert.component';
import { JobRepostComponent } from './components/job-repost/job-repost.component';
import { AddJobButtonComponent } from './components/buttons/add-job-button/add-job-button.component';
import { ImageEditorComponent } from './components/image-editor/image-editor.component';
import { SuccessDialogComponent } from './components/dialogs';
import { ImageCropperModule } from 'ngx-image-cropper';
import { JobPreviewComponent } from './components/job-preview/job-preview.component';
import { FileDropDirective } from './directives/file-drop.directive';
import { SuccessCreateJobDialogComponent } from './components/dialogs';
import { SahbakTipsComponent } from './components/sahbak-tips/sahbak-tips.component';
import { ContactDialogComponent } from './components/dialogs';
import { AgePipe } from './pipes/age.pipe';
import { IsAuthDirective } from './directives/is-auth.directive';
import { ConfirmDialogComponent } from './components/dialogs';
import { SalaryFieldComponent } from './components/salary-field/salary-field.component';
import { SuccessDialogFastComponent, ErrorDialogComponent } from './components/dialogs';
import { BillingComponent } from './components/billing/billing.component';
import { CandidateDialogComponent } from './components/dialogs/candidate-dialog/candidate-dialog.component';
import { ChatDialogComponent } from './components/dialogs/chat-dialog/chat-dialog.component';
import {ChatBoxComponent} from '../dashboard/inbox/helpers/chat-box.component';
import { QuestionsListComponent, QuestionComponent, QuestionEditorDialogComponent } from './components/questions-helpers';
import { WhatsappPipe } from './pipes/whatsapp.pipe';
import { TermsDialogComponent } from './components/dialogs/terms-dialog/terms-dialog.component';
import { ChipListComponent } from './components/chip-list/chip-list.component';
import { NearRegionsSearchComponent } from './components/near-regions-search/near-regions-search.component';
import { CountDownComponent } from './components/count-down/count-down.component';


const MATERIALS_MODULES = [
  MatInputModule,
  MatFormFieldModule,
  MatTabsModule,
  MatCheckboxModule,
  MatSidenavModule,
  MatSelectModule,
  MatDialogModule,
  MatSliderModule,
  MatIconModule,
  MatTableModule,
  MatSlideToggleModule,
  MatExpansionModule,
  MatProgressSpinnerModule,
  MatMenuModule,
  MatChipsModule,
  MatAutocompleteModule,
  MatRadioModule,
  MatTooltipModule,
];

const MODULES = [
  NgSelectModule,
  FlexLayoutModule,
  AngularSvgIconModule,
  NgxSpinnerModule,
];

const COMPONENTS = [
  SidebarComponent,
  ProfileAvatarComponent,
  HeaderComponent,
  MobileMenuComponent,
  AlertComponent,
  FormFieldComponent,
  SelectComponent,
  JobRepostComponent,
  AddJobButtonComponent,
  ImageEditorComponent,
  JobPreviewComponent,
  SuccessDialogComponent,
  SuccessCreateJobDialogComponent,
  ContactDialogComponent,
  ConfirmDialogComponent,
  SahbakTipsComponent,
  SalaryFieldComponent,
  SuccessDialogFastComponent,
  ErrorDialogComponent,
  BillingComponent,
  ErrorDialogComponent,
  CandidateDialogComponent,
  ChatBoxComponent,
  ChatDialogComponent,
  QuestionsListComponent,
  QuestionComponent,
  QuestionEditorDialogComponent,
  TermsDialogComponent,
  NearRegionsSearchComponent,
  CountDownComponent,
];

const PIPES = [
  AgePipe,
  WhatsappPipe,

];

const DIRECTIVES = [IsAuthDirective];
@NgModule({
  declarations: [
    ...COMPONENTS,
    ...PIPES,
    ...DIRECTIVES,
    FileDropDirective,
    ChipListComponent,

  ],
  exports: [
    ...COMPONENTS,
    ...MODULES,
    ...MATERIALS_MODULES,
    ...DIRECTIVES,
    ...PIPES,
    ChipListComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ScrollingModule,
    AngularSvgIconModule,
    ImageCropperModule,
    ...MATERIALS_MODULES,
    ...MODULES,
  ],
  providers: [
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: true}}
  ],
  entryComponents: [
    SuccessDialogComponent,
    SuccessCreateJobDialogComponent,
    ImageEditorComponent,
    ContactDialogComponent,
    ConfirmDialogComponent,
    SuccessDialogFastComponent,
    ErrorDialogComponent,
    CandidateDialogComponent,
    ChatDialogComponent,
    QuestionEditorDialogComponent,
    TermsDialogComponent,
  ]
})
export class SharedModule {
  constructor(matIconRegistry: MatIconRegistry) {
    matIconRegistry.registerFontClassAlias('fontawesome', 'fa');
  }
}
